<template>
  <div class="holder">
    <h1>
      净流入柱折图专用图表
      <span @click="playIn1('barLineChart')">入场</span>
      <span @click="playOut('barLineChart')">出场</span>
    </h1>
    <bar-line-Chart
      ref="barLineChart"
      id="barLineChart"
      customClass="c_line1"
    />
  </div>
</template>
<script>
import barLineChart from "@/components/marketChart/barLineChart.vue";
import data from "./kData.json";
export default {
  data: function () {
    return {};
  },
  components: { barLineChart },
  methods: {
    playIn1(refName) {
      this.$refs[refName].barLineChart(data, {
        width: 600,
        height: 400,
        marginLeft: 50,
        marginRight: 30,
        marginTop: 50,
        marginBottom: 80,

        duration: 400,
        delay: 400,
        xPadding: 0.5,
        ease: "easeBack",
        valueSuffix: "亿",
      });
    },

    playOut(refName) {
      this.$refs[refName].playOut();
    },
  },
  mounted() {},
};
</script>
<style lang="less" scoped>
.holder {
  padding: 20px;
}
h1 {
  font-size: 18px;
  margin-bottom: 8px;
  font-weight: normal;
  color: #333;
  span {
    padding: 6px;
    border-radius: 6px;
    cursor: pointer;
    font-size: 14px;
    background: #999;
    color: #fff;
    user-select: none;
    margin: 0 3px;
  }
  span:nth-of-type(1) {
    background: #447746;
  }
  span:nth-of-type(2) {
    background: #953e23;
  }
}
h2 {
  font-size: 15px;
  color: #000;
  margin-bottom: 10px;
  font-weight: bold;
  .new {
    color: #fff;
    background: #f00;
    padding: 0.5rem;
    border-radius: 0.3125rem;
    margin-right: 0.625rem;
  }
}
p {
  margin-bottom: 20px;
}

.c_line1 {
  margin-bottom: 20px;
  min-height: 200px;
  background: #fff;
  // background: -webkit-linear-gradient(top right, #e5884f, #e16906);
  // background: -moz-linear-gradient(top right, #e5884f, #e16906);
  // background: linear-gradient(to bottom left, #e5884f, #e16906);
  display: inline-block;
  /deep/ .axis_x,
  /deep/ .axis_y {
    .text {
      // fill: #fff;
      font-size: 14px;
    }
    .domain,
    .tick_line {
      stroke: #fff;
    }
  }
  /deep/ .bar_negative {
    fill: #47e60e;
  }
  /deep/ .bar_positive {
    fill: #e62c0e;
  }

  /deep/ .value1_text_inside {
    fill: #fff;
  }

  /deep/ .value2_negative {
    fill: #47e60e;
  }

  /deep/ .value2_positive {
    fill: #e62c0e;
  }
  /deep/ .line2 {
    stroke: #c5c5c5;
  }
  /deep/ .line1 {
    stroke: #ffc100;
  }
  /deep/ .tick_long_line {
    stroke-width:2 ;
    stroke: rgba(141, 211, 199, 0.15);
  }
}
</style>
